// extracted by mini-css-extract-plugin
export var searchHeader = "_9a-0";
export var searchHeaderDark = "_9a-1";